"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabItemSelected = exports.tabItemDisabled = exports.tabItemBase = void 0;

var _stylitas = require("@creditas/stylitas");

const tabItemBase = ({
  theme
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.paragraph(theme)}
  color: ${_stylitas.utilities.palette.color(theme, 'neutral07')};
  cursor: pointer;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 16px 8px;

  &:hover {
    color: ${_stylitas.utilities.palette.color(theme, 'secondary06')};
  }

  &:focus {
    outline: none;
  }
`;

exports.tabItemBase = tabItemBase;

const tabItemDisabled = ({
  theme,
  variant
}) => variant === 'disabled' && (0, _stylitas.css)`
    color: ${_stylitas.utilities.palette.color(theme, 'neutral05')};
    cursor: not-allowed;

    &:hover,
    &:focus {
      color: ${_stylitas.utilities.palette.color(theme, 'neutral05')};
    }
  `;

exports.tabItemDisabled = tabItemDisabled;

const tabItemSelected = ({
  theme,
  variant
}) => variant === 'selected' && (0, _stylitas.css)`
    ${_stylitas.utilities.typography.weight.semiBold()}
    border-bottom: 2px solid ${_stylitas.utilities.palette.color(theme, 'secondary04')};

    &:hover {
      color: ${_stylitas.utilities.palette.color(theme, 'neutral07')};
    }
  `;

exports.tabItemSelected = tabItemSelected;